import type { AnyCompanyPluginDefinition } from "./types";
import { LiveConsultPluginDialog } from "./LiveConsultPluginDialog";
import { HomeTaxPluginDialog } from "./HomeTaxPluginDialog";

/**
 * 등록 가능한 플러그인 목록. + 버튼을 누르면 이 배열에서 이미 등록된 종류를 뺀 나머지가 보인다.
 * 배열 순서가 곧 + 목록의 순서다.
 */
export const COMPANY_PLUGIN_DEFINITIONS: AnyCompanyPluginDefinition[] = [
  {
    type: "LIVE_CONSULT",
    name: "실시간 상담",
    description:
      "카카오 채널 또는 채널톡으로 쇼핑몰 우측 하단에 상담 버튼을 띄웁니다.",
    // 특정 채널(카카오)이 아닌 기능 아이콘. 채널별 로고는 등록 다이얼로그의 채널 선택에서만 쓴다
    iconSrc: "/assets/icons/Chat.svg",
    summarize: (config) =>
      config.consultChannelType === "KAKAO_CHANNEL"
        ? `카카오 채널 · ${config.kakaoChannelUrl ?? ""}`
        : "채널톡 · 플러그인 키 등록됨",
    Dialog: LiveConsultPluginDialog,
  },
  {
    // 이름은 예전 내 회사 정보 텍스트필드의 라벨을 그대로 쓴다
    type: "HOME_TAX",
    name: "홈택스 세금계산서 / 현금영수증 발급",
    description: "주문 고객에게 세금계산서·현금영수증을 국세청으로 바로 발급합니다.",
    iconSrc: "/assets/icons/Document.svg",
    summarize: (config) =>
      !config.memberId
        ? "재연동 필요 · 담당자 정보를 입력해 다시 저장해 주세요"
        : `연동됨 · ${config.autoIssue ? "자동 발급" : "수동 발급"} · ${config.contactEmail ?? ""}`,
    Dialog: HomeTaxPluginDialog,
  },
];
